export type TListingPageResponse = {
  breadcrumb: (
    | {
        title: string;
        url: string;
      }
    | {
        title: string;
        url: string;
      }[]
  )[];
  data: [
    {
      img: string;
      text: string;
      text_2?: string;
      title: string;
      url: string;
      h1?: string;
    },
  ];
  meta: {
    meta_description: string;
    meta_keywords: string;
    meta_title: string;
    meta_h1: string;
  };
  h1: string;
};
